import React from 'react';
import {connect} from 'react-redux';
import {formValueSelector, reduxForm} from 'redux-form';
import CartEntryRosterForm from './CartEntryRosterForm.jsx';
import RosterListContainer from './RosterListContainer.jsx';
import {setRosterConfirmationVisibility} from '../shared/actionTypes';
import {
  validate,
  handleSave,
  handleCountryChange,
  handleAssignTeamOwnedVirtualEventClick
} from './actions';

const CartEntryRosterFormWrapper = reduxForm({
  form: 'entryForm',
  roster: <RosterListContainer/>,
  destroyOnUnmount: false
})(CartEntryRosterForm);

const selector = formValueSelector('entryForm');

const mapStateToProps = (state, props) => ({
  disableState: props.disableState,
  validate: validate,
  countries: state.registration.shared.countries,
  states: state.registration.shared.states,
  rosterPositionsQty: selector(state, 'rosterPositionsQty'),
  parentVirtualEntryEvents: state.registration.shared.parentVirtualEntryEvents,
  parentTeamOwnedVirtualEntries: state.registration.shared.parentTeamOwnedVirtualEntries,
  entryId: selector(state, 'id'),
  eventId: state.registration.shared.cartEntries.find(x => x.editing) ? state.registration.shared.cartEntries.find(x => x.editing).eventId : null,
  maxEntries: selector(state, 'maxEntries')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSave(data)),
  onCancelClick: () => dispatch(setRosterConfirmationVisibility(true)),
  onCountryChange: value => dispatch(handleCountryChange(value)),
  onAssignTeamOwnedVirtualEventClick: (virtualEventName, teamEntryId, value) => dispatch(handleAssignTeamOwnedVirtualEventClick(virtualEventName, teamEntryId, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CartEntryRosterFormWrapper);



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CartEntryFormContainer.jsx